/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./waitingList.vue?vue&type=template&id=e9690a12&scoped=true&"
import script from "./waitingList.vue?vue&type=script&lang=js&"
export * from "./waitingList.vue?vue&type=script&lang=js&"
import style0 from "./waitingList.vue?vue&type=style&index=0&id=e9690a12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9690a12",
  null
  
)

export default component.exports